import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../toast/Toasts";

export const getWalletBalance = createAsyncThunk(
  "Wallet/GetCurrentWalletBalanceUserWise",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/GetCurrentWalletBalanceUserWise`,
        {
          UserID: localStorage.getItem("user_id"),
          // "user_guid": "54a325b6-ac11-488b-9849-6dd0f4ddcdaa"
        }
      );
      //   SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get wallet balance:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertTempWalletBalance = createAsyncThunk(
  "Wallet/InsertTempWalletBalance",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/InsertTempWalletBalance`,
        formData
      );
      // SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error insert temp wallet balance:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const verifyWalletAmount = createAsyncThunk(
  "RazorpayGateway/WalletAmountVerify",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/RazorpayGateway/WalletAmountVerify`,
        payload
      );

      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Payment verification failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Payment verification failed",
      });
    }
  }
);

export const generateGiftCodeOTP = createAsyncThunk(
  "GiftCode/GiftCodeOTPGenerate",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/GiftCodeOTPGenerate`,
        payload
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      console.error("OTP generate failed:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "OTP generate failed",
      });
    }
  }
);

export const redeemGiftCode = createAsyncThunk(
  "GiftCode/UseGiftCode",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/UseGiftCode`,
        payload
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      console.error("Reedem code failed:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Reedem code failed",
      });
    }
  }
);

export const insertWithdrawlRequest = createAsyncThunk(
  "Wallet/InsertWithdrawlRequest",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/InsertWithdrawlRequest`,
        payload
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Insert Withdrawal Request failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Insert Withdrawal Request failed",
      });
    }
  }
);

export const updateWithdrawlRequest = createAsyncThunk(
  "Wallet/UpdateWithdrawlRequest",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/UpdateWithdrawlRequest`,
        payload
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Update Withdrawal Request failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Update Withdrawal Request failed",
      });
    }
  }
);

export const getGiftCodeDetails = createAsyncThunk(
  "GiftCode/FindByGiftCode",
  async (giftCode: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/FindByGiftCode`,
        {
          GiftCode: giftCode,
        }
      );
      //   SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get giftcode balance:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWithdrawlRequest = createAsyncThunk(
  "Wallet/FindByIDWithdrawlRequest",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/FindByIDWithdrawlRequest`,
        {
          ID: ID,
        }
      );
      //   SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get withdraw request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWalletWithdrawalHistory = createAsyncThunk(
  "Wallet/GetWithdrawlRequestUserWise",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/GetWithdrawlRequestUserWise`,
        {
          UserID: parseInt(localStorage.getItem("user_id") || "0"),
        }
      );
      //   SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get wallet withdrawal:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWalletTransctionHistory = createAsyncThunk(
  "Wallet/GetWalletTransactionUserWise",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/GetWalletTransactionUserWise`,
        {
          UserID: parseInt(localStorage.getItem("user_id") || "0"),
        }
      );
      //   SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get wallet Transctions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWithdrawlRequest = createAsyncThunk(
  "Wallet/DeleteWithdrawlRequest",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/DeleteWithdrawlRequest`,
        {
          ID: ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error delete wallet withdrawal:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getGiftCodeLedger = createAsyncThunk(
  "GiftCode/GiftCodeLedgerforCustomer",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/GiftCodeLedgerforCustomer`,
        formData
      );
      //   SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get giftcode ledger:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
